<template>
  <div class="row">
    <div class="input-field col s12">
      <label :for="name" class="width-1 nowrap active">{{ label }}</label>
      <input
        v-model.trim="inputValue"
        :id="name"
        :class="{ 'invalid': !!errorMessage, [inputClass]: true, 'center-align': align === 'center' }"
        :autocomplete="autocomplete"
        class="width-1"
        placeholder=""
        ref="input"
        type="text"
        @change="$emit('change', inputValue)"
        @keyup.enter="$emit('enter')"
      />
      <span v-if="errorMessage" class="helper-text nowrap" :data-error="errorMessage"></span>
      <div
        v-if="clearable && inputValue && !$refs.input.disabled"
        class="clear-icon"
        @click.prevent="
          inputValue = '';
          $refs.input.focus();
        "
      >
        <i class="material-icons">clear</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    align: {
      type: String,
      default: 'center',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
  },
  data: () => ({
    inputValue: '',
  }),
  watch: {
    value() {
      this.inputValue = this.value;
    },
    inputValue(val) {
      this.$emit('input', val);
    },
  },
  mounted() {
    this.inputValue = this.value;
  },
  methods: {
    focus: function () {
      this.$refs.input.focus();
    },
  },
};
</script>
